<template>
  <div class="container">
    <div class="left"
         style="border-right: 1px solid #eda91b">
      <div class="fatherClass">
        <div class="titleclass">
          <h3 v-html='title'> </h3>
        </div>
        <div v-html='article'
             class="articleClass">

        </div>
      </div>

    </div>
    <div class="center">
      <div style="padding: 8px;width: auto;overflow: hidden;font-size: 24px;border-bottom: solid 1px red;color:red;">
        系统提示：审核结果仅为参考建议，非强制性要求，可酌情采用。若有异议，请联系技术人员。
      </div>
      <div style="width: 100%; height: calc(100vh - 70px); overflow-y: auto; overflow-x: hidden"
           :class="[ifImage == 1 ? 'addImg' : '']">
        <div style="font-size: 14px"
             class="card"
             v-for="item in tempListData"
             :key="item.startPos">
          <div style="width: 100%; height: 20%">
            <p style="
                  float: left;
                  margin-top: 12px;
                  margin-left: 15px;
                  color: #eda91b;
                ">
              {{ errorWord }}
            </p>
            <div :class="[currentRightSpan == '11' ? 'caozuo_AllDiv' : 'caozuo_changeDiv']"
                 style="display:none">
              <a href="javascript:void(0)"
                 @click.stop
                 v-show="item.isDeal == 0"
                 @click="replaceWord(item.startPos,item.type)"
                 class="caozuoTitle">
                替换
              </a>
              <a href="javascript:void(0)"
                 @click.stop
                 v-show="item.isDeal == 0"
                 @click="ignoreWord(item.startPos,item.type)"
                 class="caozuoTitle">
                忽略
              </a>
              <a href="javascript:void(0)"
                 v-show="item.isDeal == 1"
                 @click="revokeWord(item.startPos,item.type)"
                 class="caozuoTitle">
                撤销
              </a>
            </div>
          </div>
          <div style="width: 100%; height: 80%">
            <table id="keywordTb"
                   @click="addBgColor(item.startPos,item.type)">
              <tr>
                <td style="width:25%;">疑似错误：</td>
                <td>{{ item.sourceKeyWord }}</td>
              </tr>
              <tr>
                <td>建议改正：</td>
                <td>{{ item.replaceKeyword }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="right"
         style="z-index: 99999">
      <div :class="[currentRightSpan == item.id ? 'changeBk' : '']"
           @click="rightSpanClick(item.id)"
           :style="item.style"
           v-for="item in rightSpan"
           :key="item.id">
        <div class="top">
          {{ item.countNum }}
          <div class="circular"
               :style="{ 'background-color': item.circular }"></div>
        </div>
        <div class="body"
             :style="item.titleStyle">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>  
<script>

import { verifyText, getDataList } from "../api/index";
import { quillEditor } from "vue-quill-editor";
import VueUeditorWrap from "vue-ueditor-wrap";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { replaceAt } from "../utils/index";

export default {
  data() {
    return {
      //文章标题
      title: '',
      //文章内容
      article: '',
      //存储标题
      temtitle: '',
      //存储内容
      temArticle: '',
      //标题错误
      titleList: [],
      //文章错误
      articleList: [],
      //存储listdata数据的
      tempListData: [],
      //全部数据以及正确数据
      listData: [],
      //错误文段
      enderContent: '',
      //错误字词
      errorWord: "错误字丶词",
      //无数据时，显示的图片
      ifImage: true,
      //用于渲染段落数据
      tempContent: "",

      //params提交数据的字符串
      params: {},
      //提交参数
      saveData: {},
      currentTag: 10000,
      currentRightSpan: 11,
      //最右侧卡片
      rightSpan: [
        {
          id: "11",
          title: "全部错误",
          style:
            "height: 120px;border-radius: 10px;margin-top: 15px;margin-left: 16px;",
          circular: "transparent",
          titleStyle: "font-size: 15px",
          countNum: 0,
        },

        // {
        //   id: "22",
        //   title: "修改记录",
        //   style:
        //     "height: 120px;border-radius: 10px;margin-top: 16px;margin-left: 16px;",
        //   circular: "#34c68c",
        //   titleStyle: "color: #34c68c;font-size: 15px;display:none",
        //   countNum: 0,
        // },
      ],
    };
  },

  async mounted() {

    this.saveData.baseDomain = this.$route.query.baseDomain;
    this.saveData.articleId = this.$route.query.articleId;
    console.log(this.saveData);
    getDataList(this.saveData).then((data) => {
      this.$store.commit("saveTitle", data.Title.SourceText);
      this.$store.commit("saveTitleList", data.Title.CheckItems);
      this.$store.commit("saveContent", data.Content.SourceText);
      this.$store.commit("saveContentList", data.Content.CheckItems);

      //往标题和文字中分别加入识别标识0韦标题1为文字
      for (var i = 0; i < data.Title.CheckItems.length; i++) {
        data.Title.CheckItems[i].type = 0;
        console.log(data.Title.CheckItems.length);
        this.listData.push(data.Title.CheckItems[i]);
      }
      for (var i = 0; i < data.Content.CheckItems.length; i++) {
        data.Content.CheckItems[i].type = 1;
        this.listData.push(data.Content.CheckItems[i]);
      }

      this.tempListData = this.listData;
      // this.countNum();
      this.DealData()
      this.countNum()


    })
  },
  watch: {
    tempListData(newValue) {
      this.ifImage = false;
      if (newValue.length == 0) {
        this.ifImage = true;
      }
    },
  },
  methods: {
    //处理数据
    DealData() {
      this.title = this.$store.state.saveTitle;
      this.article = this.$store.state.saveContent;

      for (var i = this.listData.length - 1; i >= 0; i--) {

        var sourceKeyWordText =
          '<span style=\"border-bottom:2px solid #FF9800;"\>' +
          this.listData[i].sourceKeyWord +
          "</span>";
        if (this.listData[i].type == 0) {

          this.title = replaceAt(
            this.title,
            this.listData[i].startPos,
            this.listData[i].sourceKeyWord,
            sourceKeyWordText
          );
        } if (this.listData[i].type == 1) {

          this.article = replaceAt(
            this.article,
            this.listData[i].startPos,
            this.listData[i].sourceKeyWord,
            sourceKeyWordText
          );
        }
        this.listData[i].sourceKeyWordText = sourceKeyWordText;

        var replaceKeywordText =
          '<span style="color:#000;">' +
          this.listData[i].replaceKeyword +
          "</span>";
        this.listData[i].replaceKeywordText = replaceKeywordText;

        var sourceKeyWordText_hulv =
          '<span style="color:#000;">' +
          this.listData[i].sourceKeyWord +
          "</span>";
        this.listData[i].sourceKeyWordText_hulv = sourceKeyWordText_hulv;

        this.listData[i].isDeal = 0;
        this.listData[i].caozuo = 0; //0为未处理 1为替换 2为忽略 3为删除
      }

      this.tempListData = this.listData;
    },
    addBgColor(startPos, type) {
      var obj = this.findById(this.listData, startPos, type);
      this.title = this.$store.state.saveTitle;
      this.article = this.$store.state.saveContent;

      for (let item of this.listData) {
        let isCurrentItem = item.startPos === obj.startPos && item.type == obj.type;


        let sourceKeyWordText = `<span style="border-bottom:2px solid #FF9800;${isCurrentItem ? "background-color: #FFE5BF;" : ""}">${item.sourceKeyWord}</span>`;
        if (item.type === 0) {
          this.title = this.title.replace(item.sourceKeyWord, sourceKeyWordText);
        } else if (item.type === 1) {
          this.article = this.article.replace(item.sourceKeyWord, sourceKeyWordText);
        }
        item.sourceKeyWordText = sourceKeyWordText;
      }
      this.tempListData = this.listData;
      this.currentListData(this.currentRightSpan);
    },
    //校验文本按钮
    // async checkArticl() {
    //   var Content = this.tempContent;

    //   this.clearData();

    //   this.tempContent = Content;
    //   this.tempContent = this.tempContent.replace(/&nbsp;/gi, "")
    //   this.tempContent = this.tempContent.replace(/\s+/g, "");
    //   this.tempContent = this.tempContent.replace(/<[^>]+>/g, '')

    //   if (this.tempContent == '' || this.tempContent.length < 10 || this.tempContent.length > 2000) {
    //     this.$message({
    //       message: "请正确输入10-2000字符文字",
    //       type: 'error'
    //     })
    //     return
    //   }
    //   console.log(this.$route.query.account_id);
    //   console.log(this.$route.query.account_id);
    //   this.params.AccountId = this.$route.query.account_id;
    //   this.params.Content = this.tempContent;


    //   verifyText(this.params).then((data) => {

    //     if (data.is_success == true) {
    //       this.enderContent = data.Result.SourceText;
    //       this.listData = data.Result.CheckItems;
    //       this.$store.commit("saveContent", this.enderContent);
    //       this.tempContent = this.$store.state.enderContent;

    //       this.$store.commit("saveList", this.listData);
    //       this.tempListData = this.$store.state.tempList;

    //       this.DealData();

    //       this.countNum();

    //     } else {
    //       this.$message({
    //         message: data.message,
    //         type: 'error'
    //       })

    //     }
    //   })

    // },
    //清空
    // clearData() {
    //   this.tempListData = [];           
    //   });
    // },
    //计算最右侧总数
    countNum() {
      //全部数据统计
      var allDataList = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
      //leve==1为一般 2为严重
      //修改数据统计
      var changeData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 1;
      });
      this.rightSpan.forEach(function (item, index, arr) {
        if (item.id == "11") {
          item.countNum = allDataList.length;
        }

        if (item.id == "22") {
          item.countNum = changeData.length;
        }
      });
    },

    //点击替换
    replaceWord(startPos, type) {
      console.log(this.listData);
      console.log(this.title);

      var obj = this.findById(this.listData, startPos, type);
      console.log(obj);
      console.log(999);
      if (type == 0) {
        this.title = this.title.replace(
          obj.sourceKeyWordText,
          obj.replaceKeyword
        )
      } else if (type == 1) {
        this.article = this.article.replace(
          obj.sourceKeyWordText,
          obj.replaceKeyword
        )
      }
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].startPos == obj.startPos) {
          this.listData[i].isDeal = 1;
          this.listData[i].caozuo = 1;
        }
      }
      this.countNum();

      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
    },
    //点击忽略
    ignoreWord(startPos, type) {
      var obj = this.findById(this.listData, startPos, type);
      if (obj == undefined) {
        return;
      }
      if (type == 0) {
        this.title = this.title.replace(
          obj.sourceKeyWordText,
          obj.sourceKeyWordText_hulv
        )
      } else if (type == 1) {
        this.article = this.article.replace(
          obj.sourceKeyWordText,
          obj.sourceKeyWordText_hulv
        )
      }
      for (var i = 0; i < this.listData.length; i++) {
        if (this.listData[i].startPos == obj.startPos) {
          this.listData[i].isDeal = 1;
          this.listData[i].caozuo = 2;
        }
      }
      this.countNum();

      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 0;
      });
    },
    //点击撤销
    revokeWord(startPos, type) {
      console.log(888888888887777);
      var obj = this.findById(this.listData, startPos, type);
      if (obj == undefined) {
        return;
      }
      //替换
      if (obj.caozuo == 1 && obj.isDeal == 1) {
        if (type == 0) {
          this.title = this.title.replace(
            obj.replaceKeyword,
            obj.sourceKeyWordText
          )
          console.log("tihuan1");
        } else if (type == 1) {
          this.article = this.article.replace(
            obj.replaceKeyword,
            obj.sourceKeyWordText
          )
          console.log("tihuan2");
        }


        for (var i = 0; i < this.listData.length; i++) {
          if (this.listData[i].startPos == obj.startPos) {
            this.listData[i].isDeal = 0;
            this.listData[i].caozuo = 0;
          }
        }
      } else if (obj.caozuo == 2 && obj.isDeal == 1) {
        //忽略

        if (type == 0) {
          this.title = this.title.replace(
            obj.sourceKeyWordText_hulv,
            obj.sourceKeyWordText
          )
        } else if (type == 1) {
          this.article = this.article.replace(
            obj.sourceKeyWordText_hulv,
            obj.sourceKeyWordText
          )
        }


        for (var i = 0; i < this.listData.length; i++) {
          if (this.listData[i].startPos == obj.startPos) {
            this.listData[i].isDeal = 0;
            this.listData[i].caozuo = 0;
          }
        }
      }
      this.countNum();
      this.tempListData = this.listData.filter((item, index, arr) => {
        return item.isDeal == 1;
      });
    },
    rightSpanClick(index) {
      this.currentRightSpan = index;
      this.currentListData(index);
    },
    currentListData(rsId = "11") {
      //需要过滤一下数据是否处理 isdeal
      if (rsId == "11") {
        this.tempListData = this.listData.filter((item, index, arr) => {
          return item.isDeal == 0;
        });
      }

      if (rsId == "22") {
        this.tempListData = this.listData.filter((item, index, arr) => {
          return item.isDeal == 1;
        });
      }
    },
    findById(array, startPos, type) {
      // 使用 Array.prototype.find() 方法查找特定对象
      return array.find(function (element) {
        return element.startPos === startPos && element.type === type;
      });
    },
  },
  components: {
    quillEditor,
    VueUeditorWrap,
  },
};
</script>
  
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.container {
  display: flex;
  width: 100%;
  height: 100%;
}

.left {
  width: 70%;
  height: 100%;
}

.center {
  flex: 1;
}

.right {
  width: 6%;
  height: 99%;
  border-left: 1px solid #eda91b;
  /*border-radius: 5px;*/
  margin: 8px 10px;
}

.head {
  position: absolute;
  width: 100%;
  height: 100%;
}

.card {
  display: block;
  margin: 15px;
  box-shadow: 2px 2px 4px -1px rgb(0 0 0 / 5%);
  border-radius: 4px;
  border: 2px solid #efefef;
  cursor: pointer;
  border-left: 3px solid #eda91b;
  background-color: #ffffff;
  width: 95%;
  height: 14%;
}

.center div:nth-child(n + 2) {
  margin-top: 5px;
}

.right div:hover {
  background-color: #f2fafd;
  border-radius: 10px;
}

.changeBk {
  background-color: #e5f5fc;
}

.top {
  position: relative;
  width: 100%;
  height: 50%;
  text-align: center;
  font-size: 30px;
  line-height: 96px;
}

.circular {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 15px;
  right: 15px;

  /* background-color: #ED601B; */
  border-radius: 50%;

  /* float: right; */
}

.body {
  margin-top: 10px;
  text-align: center;
}

.btnClass {
  position: fixed;
  bottom: 35px;
  display: flex;
  width: 65%;
  justify-content: space-around;
}

.ql-editor {
  padding: 0 !important;
  margin: 0 !important;
}

.card:hover {
  background-color: #f6f6f6;
}

.ql-container {
  font-size: 30px;
}

.addImg {
  background-image: url('../assets/nodata.png');
  background-repeat: no-repeat;
  background-position: center center;
}

#keywordTb {
  border-collapse: collapse;
  width: 100%;
  height: 97.5%;
  border: 1px solid #ddd;
  font-size: 14px;
}

#keywordTb tr {
  height: 30%;
}

#keywordTb td {
  border: 1px solid #ddd;
  padding: 5px;
  text-align: left;
}

#keywordTb tr:nth-child(even) {
  background-color: #f2f2f2;
}

#keywordTb tr:hover {
  background-color: #ddd;
}

#keywordTb tr:nth-child(1) td:nth-child(2) {
  color: #ff9800;
}

/* #keywordTb tr td:nth-child(2) {
    padding: 10px 10px 0px 10px;
  } */
#keywordTb tr:nth-child(2) {
  border-radius: 10px;
}

.caozuo_AllDiv {
  width: 20%;
  float: right;
  margin-right: 16px;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.caozuo_changeDiv {
  width: 20%;
  float: right;
  margin-right: 16px;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.caozuoTitle {
  text-decoration: none;
  margin-top: 8px;
  color: #2fb2e5;
}

.fatherClass {
  border: 1px solid #8b7d7b;
  width: 100%;
  height: 100%;
}

.titleclass {
  height: 8%;
  border-bottom: 1px solid #8b7d7b;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 20px;
}

h3 {
  margin: 0;
}

.articleClass {
  height: 90%;
  padding: 10px;
}
</style>